

<div class="award__box {{ class }}" [ngClass]="{'disabled': disabled}">

  <div class="flex-grow-1 d-flex flex-column" [routerLink]="(disabled || !award?.subcategory || !award.category) ? null : ['/biznes/nagrody', award?.category?.slug, award?.subcategory.slug, award?.award?.slug]">
    <div class="image_wrapper">
      <div class="image" [style.backgroundImage]="'url(' + award.image_path + ')'"></div>
      <div class="new" *ngIf="award.is_new">NOWOŚĆ</div>
    </div>
    <p class="name flex-grow-1">
      {{ award.award.name  }}
    </p>
    <p class="points_list" *ngIf="award?.se_category?.slug !== 'meble'">
      {{ award.points | number }} pkt
    </p>
  </div>
  <ng-content></ng-content>
</div>
